/**
 * Page CMS Collection Constants
 * 
 * Collection names and constants for the Content Management System
 */

/**
 * Collection name for pages (org-scoped)
 * Stored at: /orgs/{orgUid}/pages/{pageId}
 */
export const PAGE_COLLECTION = "pages";

/**
 * Collection name for page templates (system-wide)
 * Stored at: /pageTemplates/{templateId}
 * 
 * Future: Org-specific templates at /orgs/{orgUid}/pageTemplates/{templateId}
 */
export const PAGE_TEMPLATE_COLLECTION = "pageTemplates";

/**
 * Block types for WYSIWYG editor (future)
 */
export const BLOCK_TYPES = {
  HERO: "hero",
  TEXT: "text",
  HEADING: "heading",
  IMAGE: "image",
  CARD: "card",
  CARD_GRID: "card-grid",
  CTA: "cta",
  CONTACT_INFO: "contact-info",
  NEWS_LIST: "news-list",
  FORM: "form",
  CALENDAR: "calendar",
} as const;

/**
 * Template categories
 */
export const TEMPLATE_CATEGORIES = {
  CONTENT: "content",
  LISTING: "listing",
  FORM: "form",
  CUSTOM: "custom",
} as const;
